module.exports = __webpack_public_path__ + "media/application/images/svgs/arrow-up-right-eab20761322dcaf28c92b79929bc00eb.svg";